import React, { useState, useEffect } from 'react';
import { BASE_ICONS } from '../svg';
import { MCButton } from '../basic';
import { rgba, scssVariables, remCss } from 'src/helpers';

export const AlertBox = ({ message, onClose, visible = true }) => {
  const [show, setShow] = useState(false);
  const [removing, setRemoving] = useState(false);

  useEffect(() => {
    if (visible) {
      // slight delay so animation triggers after mount
      const t = setTimeout(() => setShow(true), 10);
      return () => clearTimeout(t);
    }
  }, [visible]);

  const handleClose = () => {
    setRemoving(true);
    setTimeout(() => {
      setShow(false);
      onClose?.();
    }, 300);
  };

  let color = scssVariables['colors-mc-primary'];

  const containerStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: remCss(12),
    backgroundColor: rgba(color, 0.1),
    border: `1px solid ${rgba(color, 0.7)}`,
    borderLeft: `${remCss(4)}px solid ${rgba(color, 0.7)}`,
    borderRadius: remCss(12),
    padding: `${remCss(14)}px ${remCss(16)}px`,
    position: 'relative',
    overflow: 'hidden',
    opacity: show && !removing ? 1 : 0,
    transform: show && !removing ? 'translateY(0)' : `translateY(-${remCss(10)}px)`,
    transition: 'opacity 0.3s ease, transform 0.3s ease',
    maxWidth: '100%',
    width: 'fit-content'
  };

  const messageStyle = {
    fontSize: 20,
    color: color,
    margin: 0,
    lineHeight: '1.5',
    minWidth: 30
  };

  return (
    <div style={containerStyle}>
      <p style={messageStyle}>{message}</p>

      <MCButton onClick={handleClose} iconname={BASE_ICONS.CLOSE} width={20} />
    </div>
  );
};
